<template>
  <div class="bracket-body bracket-4" id="bracket-64" :style="'transform: scale('+zoomDraw+');'">

    <div class="title-category">{{ title }} {{ sex == 1 ? 'Чоловіки' : '' }}{{ sex == 2 ? 'Жінки' : '' }}</div>
    <div class="header-bracket">
      <div class="round round-64">Учасник</div>
    </div>

    <div class="bracket bracket-64 " v-bind:class="{'color-sheme':colorSheme}">
      <div class="bracket-left" id="bracket-items-2">


        <div class="round round-0" id="round-0">
          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_0', '6_1')">{{ getSportsmanPointsByPosition('6_0') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_0', '6_1')">{{ getSportsmanPointsByPosition('6_1') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_0" :sportsman="getSportsman('6_0')"
                                         :key="'6_0'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_0')"
                                       tehnumber="31"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_1"
                                         :sportsman="getSportsman('6_1')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_2', '6_3')">{{ getSportsmanPointsByPosition('6_2') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_2', '6_3')">{{ getSportsmanPointsByPosition('6_3') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_2" :sportsman="getSportsman('6_2')"
                                         :key="'6_2'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_1')"
                                       tehnumber="32"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_3"
                                         :sportsman="getSportsman('6_3')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_4', '6_5')">{{ getSportsmanPointsByPosition('6_4') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_4', '6_5')">{{ getSportsmanPointsByPosition('6_5') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_4" :sportsman="getSportsman('6_4')"
                                         :key="'6_4'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_2')"
                                       tehnumber="33"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_5"
                                         :sportsman="getSportsman('6_5')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_6', '6_7')">{{ getSportsmanPointsByPosition('6_6') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_6', '6_7')">{{ getSportsmanPointsByPosition('6_7') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_6" :sportsman="getSportsman('6_6')"
                                         :key="'6_6'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_3')"
                                       tehnumber="34"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_7"
                                         :sportsman="getSportsman('6_7')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_8', '6_9')">{{ getSportsmanPointsByPosition('6_8') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_8', '6_9')">{{ getSportsmanPointsByPosition('6_9') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_8" :sportsman="getSportsman('6_8')"
                                         :key="'6_8'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_4')"
                                       tehnumber="35"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_9"
                                         :sportsman="getSportsman('6_9')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_10', '6_11')">{{ getSportsmanPointsByPosition('6_10') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_10', '6_11')">{{ getSportsmanPointsByPosition('6_11') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_10"
                                         :sportsman="getSportsman('6_10')" :key="'6_10'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_5')"
                                       tehnumber="36"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_11"
                                         :sportsman="getSportsman('6_11')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_12', '6_13')">{{ getSportsmanPointsByPosition('6_12') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_12', '6_13')">{{ getSportsmanPointsByPosition('6_13') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_12"
                                         :sportsman="getSportsman('6_12')" :key="'6_12'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_6')"
                                       tehnumber="37"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_13"
                                         :sportsman="getSportsman('6_13')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_14', '6_15')">{{ getSportsmanPointsByPosition('6_14') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_14', '6_15')">{{ getSportsmanPointsByPosition('6_15') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_14"
                                         :sportsman="getSportsman('6_14')"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_7')"
                                       tehnumber="38"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_15"
                                         :sportsman="getSportsman('6_15')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_16', '6_17')">{{ getSportsmanPointsByPosition('6_16') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_16', '6_17')">{{ getSportsmanPointsByPosition('6_17') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_16"
                                         :sportsman="getSportsman('6_16')"
                                         :key="'6_16'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_8')"
                                       tehnumber="39"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_17"
                                         :sportsman="getSportsman('6_17')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_18', '6_19')">{{ getSportsmanPointsByPosition('6_18') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_18', '6_19')">{{ getSportsmanPointsByPosition('6_19') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_18"
                                         :sportsman="getSportsman('6_18')"
                                         :key="'6_18'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_9')"
                                       tehnumber="40"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_19"
                                         :sportsman="getSportsman('6_19')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_20', '6_21')">{{ getSportsmanPointsByPosition('6_20') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_20', '6_21')">{{ getSportsmanPointsByPosition('6_21') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_20"
                                         :sportsman="getSportsman('6_20')"
                                         :key="'6_20'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_10')"
                                       tehnumber="41"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_21"
                                         :sportsman="getSportsman('6_21')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_22', '6_23')">{{ getSportsmanPointsByPosition('6_22') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_22', '6_23')">{{ getSportsmanPointsByPosition('6_23') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_22"
                                         :sportsman="getSportsman('6_22')"
                                         :key="'6_22'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_11')"
                                       tehnumber="42"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_23"
                                         :sportsman="getSportsman('6_23')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_24', '6_25')">{{ getSportsmanPointsByPosition('6_24') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_24', '6_25')">{{ getSportsmanPointsByPosition('6_25') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_24"
                                         :sportsman="getSportsman('6_24')"
                                         :key="'6_24'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_12')"
                                       tehnumber="43"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_25"
                                         :sportsman="getSportsman('6_25')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_26', '6_27')">{{ getSportsmanPointsByPosition('6_26') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_26', '6_27')">{{ getSportsmanPointsByPosition('6_27') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_26"
                                         :sportsman="getSportsman('6_26')" :key="'6_26'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_13')"
                                       tehnumber="44"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_27"
                                         :sportsman="getSportsman('6_27')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_28', '6_29')">{{ getSportsmanPointsByPosition('6_28') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_28', '6_29')">{{ getSportsmanPointsByPosition('6_29') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_28"
                                         :sportsman="getSportsman('6_28')" :key="'6_28'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_14')"
                                       tehnumber="45"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_29"
                                         :sportsman="getSportsman('6_29')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('6_30', '6_31')">{{ getSportsmanPointsByPosition('6_30') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('6_30', '6_31')">{{ getSportsmanPointsByPosition('6_31') }}</span>

            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_30"
                                         :sportsman="getSportsman('6_30')"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('5_15')"
                                       tehnumber="46"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="true" technicalNumber="6_31"
                                         :sportsman="getSportsman('6_31')"></bracket-sportsman-item-draw>
          </div>


          <!--          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('4_15')"-->
          <!--                        :get-sportsman="getSportsman('6_30')"-->
          <!--                        :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_31')"-->
          <!--                        :technicalNumber1="'6_30'"-->
          <!--                        :technicalNumber2="'6_31'"-->
          <!--                        :fight-number="30" :select-fight="selectFight"/>-->

          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_16')"
                              :get-sportsman="getSportsman('6_32')"
                              :get-sportsman2="getSportsman('6_33')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_32')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_33')"
                              :points-class="scoreClass('6_32', '6_33')"
                              :technicalNumber1="'6_32'"
                              :technicalNumber2="'6_33'"
                              :fight-number="47" :select-fight="selectFight"/>

          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_17')"
                              :get-sportsman="getSportsman('6_34')"
                              :get-sportsman2="getSportsman('6_35')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_34')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_35')"
                              :points-class="scoreClass('6_34', '6_35')"
                              :technicalNumber1="'6_34'"
                              :technicalNumber2="'6_35'"
                              :fight-number="48" :select-fight="selectFight"/>


          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_18')"
                              :get-sportsman="getSportsman('6_36')"
                              :get-sportsman2="getSportsman('6_37')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_36')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_37')"
                              :points-class="scoreClass('6_36', '6_37')"
                              :technicalNumber1="'6_36'"
                              :technicalNumber2="'6_37'"
                              :fight-number="49" :select-fight="selectFight"/>

          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_19')"
                              :get-sportsman="getSportsman('6_38')"
                              :get-sportsman2="getSportsman('6_39')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_38')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_39')"
                              :points-class="scoreClass('6_38', '6_39')"
                              :technicalNumber1="'6_38'"
                              :technicalNumber2="'6_39'"
                              :fight-number="50" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_20')"
                              :get-sportsman="getSportsman('6_40')"
                              :get-sportsman2="getSportsman('6_41')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_40')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_41')"
                              :points-class="scoreClass('6_40', '6_41')"
                              :technicalNumber1="'6_40'"
                              :technicalNumber2="'6_41'"
                              :fight-number="51" :select-fight="selectFight"/>

          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_21')"
                              :get-sportsman="getSportsman('6_42')"
                              :get-sportsman2="getSportsman('6_43')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_42')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_43')"
                              :points-class="scoreClass('6_42', '6_43')"
                              :technicalNumber1="'6_42'"
                              :technicalNumber2="'6_43'"
                              :fight-number="52" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_22')"
                              :get-sportsman="getSportsman('6_44')"
                              :get-sportsman2="getSportsman('6_45')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_44')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_45')"
                              :points-class="scoreClass('6_44', '6_45')"
                              :technicalNumber1="'6_44'"
                              :technicalNumber2="'6_45'"
                              :fight-number="53" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_23')"
                              :get-sportsman="getSportsman('6_46')"
                              :get-sportsman2="getSportsman('6_47')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_46')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_47')"
                              :points-class="scoreClass('6_46', '6_47')"
                              :technicalNumber1="'6_46'"
                              :technicalNumber2="'6_47'"
                              :fight-number="54" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_24')"
                              :get-sportsman="getSportsman('6_48')"
                              :get-sportsman2="getSportsman('6_49')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_48')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_49')"
                              :points-class="scoreClass('6_48', '6_49')"
                              :technicalNumber1="'6_48'"
                              :technicalNumber2="'6_49'"
                              :fight-number="55" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_25')"
                              :get-sportsman="getSportsman('6_50')"
                              :get-sportsman2="getSportsman('6_51')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_50')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_51')"
                              :points-class="scoreClass('6_50', '6_51')"
                              :technicalNumber1="'6_50'"
                              :technicalNumber2="'6_51'"
                              :fight-number="56" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_26')"
                              :get-sportsman="getSportsman('6_52')"
                              :get-sportsman2="getSportsman('6_53')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_52')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_53')"
                              :points-class="scoreClass('6_52', '6_53')"
                              :technicalNumber1="'6_52'"
                              :technicalNumber2="'6_53'"
                              :fight-number="57" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_27')"
                              :get-sportsman="getSportsman('6_54')"
                              :get-sportsman2="getSportsman('6_55')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_54')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_55')"
                              :points-class="scoreClass('6_54', '6_55')"
                              :technicalNumber1="'6_54'"
                              :technicalNumber2="'6_55'"
                              :fight-number="58" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_28')"
                              :get-sportsman="getSportsman('6_56')"
                              :get-sportsman2="getSportsman('6_57')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_56')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_57')"
                              :points-class="scoreClass('6_56', '6_57')"
                              :technicalNumber1="'6_56'"
                              :technicalNumber2="'6_57'"
                              :fight-number="59" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_29')"
                              :get-sportsman="getSportsman('6_58')"
                              :get-sportsman2="getSportsman('6_59')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_58')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_59')"
                              :points-class="scoreClass('6_58', '6_59')"
                              :technicalNumber1="'6_58'"
                              :technicalNumber2="'6_59'"
                              :fight-number="60" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_30')"
                              :get-sportsman="getSportsman('6_60')"
                              :get-sportsman2="getSportsman('6_61')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_60')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_61')"
                              :points-class="scoreClass('6_60', '6_61')"
                              :technicalNumber1="'6_60'"
                              :technicalNumber2="'6_61'"
                              :fight-number="61" :select-fight="selectFight"/>
          <BracketFigtSection :get-fight-number-by-position="getFightNumberByPosition('5_31')"
                              :get-sportsman="getSportsman('6_62')"
                              :get-sportsman2="getSportsman('6_63')"
                              :get-sportsman-points-by-position="getSportsmanPointsByPosition('6_62')"
                              :get-sportsman-points-by-position2="getSportsmanPointsByPosition('6_63')"
                              :points-class="scoreClass('6_62', '6_63')"
                              :technicalNumber1="'6_62'"
                              :technicalNumber2="'6_63'"
                              :fight-number="62" :select-fight="selectFight"/>


        </div>

        <div class="round round-1" id="round-1">
          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_0', '5_1')">{{ getSportsmanPointsByPosition('5_0') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_0', '5_1')">{{ getSportsmanPointsByPosition('5_1') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_0" :sportsman="getSportsman('5_0')"
                                         :key="'5_0'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_0')"
                                       tehnumber="15"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_1"
                                         :sportsman="getSportsman('5_1')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_2', '5_3')">{{ getSportsmanPointsByPosition('5_2') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_2', '5_3')">{{ getSportsmanPointsByPosition('5_3') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_2" :sportsman="getSportsman('5_2')"
                                         :key="'5_2'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_1')"
                                       tehnumber="16"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_3"
                                         :sportsman="getSportsman('5_3')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_4', '5_5')">{{ getSportsmanPointsByPosition('5_4') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_4', '5_5')">{{ getSportsmanPointsByPosition('5_5') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_4" :sportsman="getSportsman('5_4')"
                                         :key="'5_4'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_2')"
                                       tehnumber="17"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_5"
                                         :sportsman="getSportsman('5_5')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_6', '5_7')">{{ getSportsmanPointsByPosition('5_6') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_6', '5_7')">{{ getSportsmanPointsByPosition('5_7') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_6" :sportsman="getSportsman('5_6')"
                                         :key="'5_6'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_3')"
                                       tehnumber="18"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_7"
                                         :sportsman="getSportsman('5_7')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_8', '5_9')">{{ getSportsmanPointsByPosition('5_8') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_8', '5_9')">{{ getSportsmanPointsByPosition('5_9') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_8" :sportsman="getSportsman('5_8')"
                                         :key="'5_8'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_4')"
                                       tehnumber="19"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_9"
                                         :sportsman="getSportsman('5_9')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_10', '5_11')">{{ getSportsmanPointsByPosition('5_10') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_10', '5_11')">{{ getSportsmanPointsByPosition('5_11') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_10"
                                         :sportsman="getSportsman('5_10')" :key="'5_10'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_5')"
                                       tehnumber="20"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_11"
                                         :sportsman="getSportsman('5_11')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_12', '5_13')">{{ getSportsmanPointsByPosition('5_12') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_12', '5_13')">{{ getSportsmanPointsByPosition('5_13') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_12"
                                         :sportsman="getSportsman('5_12')" :key="'5_12'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_6')"
                                       tehnumber="21"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_13"
                                         :sportsman="getSportsman('5_13')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_14', '5_15')">{{ getSportsmanPointsByPosition('5_14') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_14', '5_15')">{{ getSportsmanPointsByPosition('5_15') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_14"
                                         :sportsman="getSportsman('5_14')"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_7')"
                                       tehnumber="22"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_15"
                                         :sportsman="getSportsman('5_15')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_16', '5_17')">{{ getSportsmanPointsByPosition('5_16') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_16', '5_17')">{{ getSportsmanPointsByPosition('5_17') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_16"
                                         :sportsman="getSportsman('5_16')"
                                         :key="'5_16'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_8')"
                                       tehnumber="23"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_17"
                                         :sportsman="getSportsman('5_17')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_18', '5_19')">{{ getSportsmanPointsByPosition('5_18') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_18', '5_19')">{{ getSportsmanPointsByPosition('5_19') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_18"
                                         :sportsman="getSportsman('5_18')"
                                         :key="'5_18'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_9')"
                                       tehnumber="24"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_19"
                                         :sportsman="getSportsman('5_19')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_20', '5_21')">{{ getSportsmanPointsByPosition('5_20') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_20', '5_21')">{{ getSportsmanPointsByPosition('5_21') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_20"
                                         :sportsman="getSportsman('5_20')"
                                         :key="'5_20'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_10')"
                                       tehnumber="25"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_21"
                                         :sportsman="getSportsman('5_21')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_22', '5_23')">{{ getSportsmanPointsByPosition('5_22') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_22', '5_23')">{{ getSportsmanPointsByPosition('5_23') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_22"
                                         :sportsman="getSportsman('5_22')"
                                         :key="'5_22'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_11')"
                                       tehnumber="26"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_23"
                                         :sportsman="getSportsman('5_23')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_24', '5_25')">{{ getSportsmanPointsByPosition('5_24') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_24', '5_25')">{{ getSportsmanPointsByPosition('5_25') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_24"
                                         :sportsman="getSportsman('5_24')"
                                         :key="'5_24'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_12')"
                                       tehnumber="27"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_25"
                                         :sportsman="getSportsman('5_25')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_26', '5_27')">{{ getSportsmanPointsByPosition('5_26') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_26', '5_27')">{{ getSportsmanPointsByPosition('5_27') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_26"
                                         :sportsman="getSportsman('5_26')" :key="'5_26'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_13')"
                                       tehnumber="28"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_27"
                                         :sportsman="getSportsman('5_27')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_28', '5_29')">{{ getSportsmanPointsByPosition('5_28') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_28', '5_29')">{{ getSportsmanPointsByPosition('5_29') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_28"
                                         :sportsman="getSportsman('5_28')" :key="'5_28'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_14')"
                                       tehnumber="29"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_29"
                                         :sportsman="getSportsman('5_29')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('5_30', '5_31')">{{ getSportsmanPointsByPosition('5_30') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('5_30', '5_31')">{{ getSportsmanPointsByPosition('5_31') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_30"
                                         :sportsman="getSportsman('5_30')"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('4_15')"
                                       tehnumber="30"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="5_31"
                                         :sportsman="getSportsman('5_31')"></bracket-sportsman-item-draw>
          </div>


        </div>

        <div class="round round-2" id="round-2">
          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_0', '4_1')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_0') }} <i style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_0', '4_1')" style="top: 100px; right: -90px">{{ getSportsmanPointsByPosition('4_1') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_0" :sportsman="getSportsman('4_0')"
                                         :key="'4_0'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_0')"
                                       tehnumber="7"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_1"
                                         :sportsman="getSportsman('4_1')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_2', '4_3')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_2') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_2', '4_3')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_3') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_2" :sportsman="getSportsman('4_2')"
                                         :key="'4_2'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_1')"
                                       tehnumber="8"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_3"
                                         :sportsman="getSportsman('4_3')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_4', '4_5')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_4') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_4', '4_5')" style="top: 100px; right: -90px;">{{ getSportsmanPointsByPosition('4_5') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_4" :sportsman="getSportsman('4_4')"
                                         :key="'4_4'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_2')"
                                       tehnumber="9"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_5"
                                         :sportsman="getSportsman('4_5')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_6', '4_7')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_6') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_6', '4_7')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_7') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_6" :sportsman="getSportsman('4_6')"
                                         :key="'4_6'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_3')"
                                       tehnumber="10"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_7"
                                         :sportsman="getSportsman('4_7')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_8', '4_9')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_8') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_8', '4_9')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_9') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_8" :sportsman="getSportsman('4_8')"
                                         :key="'4_8'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_4')"
                                       tehnumber="11"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_9"
                                         :sportsman="getSportsman('4_9')"></bracket-sportsman-item-draw>
          </div>

          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_10', '4_11')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_10') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_10', '4_11')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_11') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_10"
                                         :sportsman="getSportsman('4_10')" :key="'4_10'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_5')"
                                       tehnumber="12"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_11"
                                         :sportsman="getSportsman('4_11')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_12', '4_13')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_12') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_12', '4_13')" style="top: 100px; right: -90px" >{{ getSportsmanPointsByPosition('4_13') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_12"
                                         :sportsman="getSportsman('4_12')" :key="'4_12'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_6')"
                                       tehnumber="13"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_13"
                                         :sportsman="getSportsman('4_13')"></bracket-sportsman-item-draw>
          </div>


          <div class="group " data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('4_14', '4_15')"  style="top: 100px;">{{ getSportsmanPointsByPosition('4_14') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('4_14', '4_15')" style="top: 100px;">{{ getSportsmanPointsByPosition('4_15') }}</span>

            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_14"
                                         :sportsman="getSportsman('4_14')"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('3_7')"
                                       tehnumber="14"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw :showOrganization="false" technicalNumber="4_15"
                                         :sportsman="getSportsman('4_15')"></bracket-sportsman-item-draw>
          </div>


        </div>

        <div class="round round-3">
          <div class="group" data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('3_0', '3_1')" style="top: 200px;">{{ getSportsmanPointsByPosition('3_0') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('3_0', '3_1')" style="top: 200px;">{{ getSportsmanPointsByPosition('3_1') }}</span>

            <bracket-sportsman-item-draw technicalNumber="3_0" :sportsman="getSportsman('3_0')"
                                         :key="'3_0'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('2_0')"
                                       tehnumber="3"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw technicalNumber="3_1"
                                         :sportsman="getSportsman('3_1')"></bracket-sportsman-item-draw>
          </div>

          <div class="group" data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('3_2', '3_3')" style="top: 200px;">{{ getSportsmanPointsByPosition('3_2') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('3_2', '3_3')" style="top: 200px;">{{ getSportsmanPointsByPosition('3_3') }}</span>

            <bracket-sportsman-item-draw technicalNumber="3_2" :sportsman="getSportsman('3_2')"
                                         :key="'3_2'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('2_1')"
                                       tehnumber="4"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw technicalNumber="3_3"
                                         :sportsman="getSportsman('3_3')"></bracket-sportsman-item-draw>
          </div>


          <div class="group" data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('3_4', '3_5')" style="top: 200px;">{{ getSportsmanPointsByPosition('3_4') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('3_4', '3_5')" style="top: 200px; right: -90px">{{ getSportsmanPointsByPosition('3_5') }}</span>

            <bracket-sportsman-item-draw technicalNumber="3_4" :sportsman="getSportsman('3_4')"
                                         :key="'3_4'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('2_2')"
                                       tehnumber="5"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw technicalNumber="3_5"
                                         :sportsman="getSportsman('3_5')"></bracket-sportsman-item-draw>
          </div>


          <div class="group" data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('3_6', '3_7')" style="top: 200px;">{{ getSportsmanPointsByPosition('3_6') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('3_6', '3_7')" style="top: 200px;">{{ getSportsmanPointsByPosition('3_7') }}</span>

            <bracket-sportsman-item-draw technicalNumber="3_6" :sportsman="getSportsman('3_6')"
                                         :key="'3_6'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('2_3')"
                                       tehnumber="6"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw technicalNumber="3_7"
                                         :sportsman="getSportsman('3_7')"></bracket-sportsman-item-draw>
          </div>


        </div>


        <div class="round round-4">
          <div class="group" data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('2_0', '2_1')" style="top: 400px;right: -70px;">{{ getSportsmanPointsByPosition('2_0') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('2_0', '2_1')" style="top: 400px;right: -90px;">{{ getSportsmanPointsByPosition('2_1') }}</span>

            <bracket-sportsman-item-draw technicalNumber="2_0" :sportsman="getSportsman('2_0')"
                                         :key="'2_0'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('1_0')"
                                       tehnumber="1"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw technicalNumber="2_1"
                                         :sportsman="getSportsman('2_1')"></bracket-sportsman-item-draw>
          </div>

          <div class="group" data-fight="1">
            <div class="line-vertical"></div>

            <span class="fight-points-blue-text" :class="scoreClass('2_2', '2_3')" style="top: 400px;">{{ getSportsmanPointsByPosition('2_2') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('2_2', '2_3')" style="top: 400px;">{{ getSportsmanPointsByPosition('2_3') }}</span>

            <bracket-sportsman-item-draw technicalNumber="2_2" :sportsman="getSportsman('2_2')"
                                         :key="'2_2'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('1_1')"
                                       tehnumber="2"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw technicalNumber="2_3"
                                         :sportsman="getSportsman('2_3')"></bracket-sportsman-item-draw>
          </div>


        </div>


        <div class="round round-5">
          <div class="group" data-fight="1">
            <div class="line-vertical to-bottom"></div>

            <span class="fight-points-blue-text" :class="scoreClass('1_0', '1_1')" style="top: 800px;">{{ getSportsmanPointsByPosition('1_0') }} <i
              style="position:absolute; top:0; right:5px; font-style: normal">:</i></span>
            <span class="fight-points-red-text" :class="scoreClass('1_0', '1_1')" style="top: 800px;">{{ getSportsmanPointsByPosition('1_1') }}</span>

            <bracket-sportsman-item-draw technicalNumber="1_0" :sportsman="getSportsman('1_0')"
                                         :key="'1_0'"></bracket-sportsman-item-draw>
            <div class="divider"></div>
            <bracket-fight-number-draw :selectBracketFight.sync="selectFight" :number="getFightNumberByPosition('0_0')"
                                       tehnumber="0"></bracket-fight-number-draw>
            <bracket-sportsman-item-draw technicalNumber="1_1"
                                         :sportsman="getSportsman('1_1')"></bracket-sportsman-item-draw>
          </div>
        </div>


        <div class="round round-6">
          <div class="group">
            <bracket-sportsman-item-draw technicalNumber="0_0"
                                         :sportsman="getSportsman('0_0')"></bracket-sportsman-item-draw>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import {Plugins, Swappable} from '@shopify/draggable';
import {guardSwappable} from 'src/utils/bracketDrag';
import {scoreClass} from 'src/utils/bracketScore';
import BracketFigtSection from "./BracketFigtSection";

export default {
  name: "bracket-2",
  components: {
    BracketFigtSection
  },
  props: {
    selectBracketFight: {
      type: Function,
      description: "Function select Bracket Fight"
    },

    resortBracketParent: {
      type: Function,
      description: "Function toogle Sortable Sheme"
    },

    toogleSortableShemeParent: {
      type: Function,
      description: "Function toogle Sortable Sheme"
    },
    colorSheme: {
      type: Boolean,
      description: "Color Sheme"
    },

    destroy: {
      type: Boolean,
      description: "Color Sheme"
    },

    sortableSheme: {
      type: Boolean,
      description: "Sortable Sheme"
    },

    drawdata: {
      type: Array,
      description: "Sortable Sheme"
    },
    // sportsmans: {
    //   type: Array,
    //   description: "List sportsmans"
    // },
    bracketFigths: {
      type: Object,
      description: "List fights"
    },
    title: {
      type: String,
      description: "Card title"
    },
    sex: {
      type: String,
      description: "Card title"
    },
    zoomDraw: {
      type: [String, Number],
      description: "Card title"
    },
    categoryid: {
      type: [String, Number],
      description: "Card title"
    },
    tournamentid: {
      type: [String, Number],
      description: "Card title"
    },
  },
  data() {
    return {
      selectedFight: '',
      swappable: null,
    }
  },


  watch: {


    categoryid: function (newVal, oldvalue) {
      if (newVal != oldvalue) {
        this.clearSwappable();
      }
    },


    destroy: function (newVal, oldvalue) {
      if (newVal == true) {
        // this.$destroy();
      }
    },

    sortableSheme: function (newVal) {
      if (newVal == true) {
        this.setSwappable();
      }
    },
  },

  beforeDestroy: function () {
    // this.clearSwappable();
  },


  computed: {
    activeBracketSize() {
      return this.$store.getters['settings/activeBracketSize'];
    },

    // sp_position_1_1: {
    //   get () {
    //     return this.fixedCost;
    //   },
    //   set (value) {
    //     this.$store.commit('updateFixedCost', {  fixedCost: value });
    //   }
    // },
  },

  methods: {

    getSportsman(position) {

      // ищим спортсмена с текущей позицией
      let result = {name: '', id: 0, organization: ' ', points: ''};

      for (let i = 0; i < this.drawdata.length; i++) {
        if (this.drawdata[i].position == position) {
          result.id = this.drawdata[i].sp_id;
          result.name = this.drawdata[i].name;
          result.organization = this.drawdata[i].organization;
          result.oblast = this.drawdata[i].oblast;
          result.points = this.drawdata[i].points;
          break;
        }
      }
      return result;

    },


    clearSwappable() {
      if (this.swappable !== null) {
        this.swappable.destroy();
        this.swappable = null;
      }
    },
    clickSelectFight(fight) {
      this.selectBracketFight(fight);
      this.selectedFight = fight;
      console.log('selectedFight', selectedFight);
    },

    setSwappable() {
      let bracketimageblock = document.getElementById('round-0');
      let pendingDrawingBlock = document.getElementById('pendingdrawingblock');

      if (bracketimageblock !== null) {
        // Destroy old element
        if (this.swappable !== null) {
          this.swappable.destroy();
          this.swappable = null;
        }

        this.swappable = new Swappable([bracketimageblock, pendingDrawingBlock], {
          draggable: '.sp-item.sortable-drag-item',
          mirror: {
            constrainDimensions: true,
          },
          delay: 0,
          plugins: [Plugins.ResizeMirror],
          dragClass: "sortable-drag",  // Class name for the dragging item
        });

        guardSwappable(this.swappable);

        this.swappable.on('drag:stop', () => this.saveBracket());
      }
    },

    saveBracket() {
      let round0 = document.getElementById('round-0'); // перша колонка зліва
      let groups = round0.getElementsByClassName('group'); // поединки
      let bracket_data = [];
      let posCount = 0;

      // определяем позиции первой линий в зависимости от сетки
      let let_first_line = '1_';

      switch (this.activeBracketSize) {
        case 2:
          let_first_line = '1_';
          break;
        case 4:
          let_first_line = '2_';
          break;

        case 8:
          let_first_line = '3_';
          break;

        case 16:
          let_first_line = '4_';
          break;

        case 32:
          let_first_line = '5_';
          break;

        case 64:
          let_first_line = '6_';
          break;

      }


      // перебираем каждый поединок
      for (let i = 0; i < groups.length; i++) {
        // получаем спортсменов в поединке
        let groupSportsmansList = groups[i].getElementsByClassName('sp-item'); // получаем всегда 2 спортсмена

        // filter groupSportsmans
        let groupSportsmans = [];
        for (let j = 0; j < groupSportsmansList.length; j++) {
          if (groupSportsmansList[j].classList.contains('draggable--original')) continue;
          groupSportsmans.push(groupSportsmansList[j]);
        }

        let sp1 = groupSportsmans[0].getAttribute('data-sp');
        if (sp1 != null && sp1 != undefined && sp1 != '') {
          bracket_data.push({position: let_first_line + posCount, id: sp1});
        }
        posCount++;


        let sp2 = groupSportsmans[1].getAttribute('data-sp');
        if (sp2 != null && sp2 != undefined && sp2 != '') {
          bracket_data.push({position: let_first_line + posCount, id: sp2});
        }
        posCount++;
      }

      let sentParams = {
        bracket_size: this.activeBracketSize,
        bracket_data: bracket_data,
        categoryid: this.categoryid,
        tournamentid: this.tournamentid,
        time: new Date().getTime(),
      };

      this.$store.dispatch('tournament/saveBracket', sentParams);
    },

    selectFight(fight) {
      this.selectBracketFight(fight)
    },

    scoreClass(bluePosition, redPosition) {
      return scoreClass(this.getSportsmanPointsByPosition(bluePosition), this.getSportsmanPointsByPosition(redPosition));
    },

    getSportsmanPointsByPosition(position) {

      let sportsman = this.getSportsman(position);
      return sportsman.points;

    },
    getFightNumberByPosition(position) {
      let fight = this.getFight(position);
      return fight;

    },
    getFight(position) {
      // ищим спортсмена с текущей позицией
      let result = {number: ''};
      for (let i = 0; i < this.drawdata.length; i++) {
        if (this.drawdata[i].position == position) {
          result.number = this.drawdata[i].number;
          result.decision = this.drawdata[i].decision;
          break;
        }
      }
      return result;
    },
  }
}
</script>
